import React, { Component } from 'react';

class LiveNFT extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  render() {
    if (this.props.liveNFTItem.mediaType === 0) {
      return (
        <video
          src={this.props.liveNFTItem.animation_url}
          className="flex sm:absolute sm:z-10 rounded-md sm:mt-8 mx-auto w-72 sm:w-auto sm:h-96"
          controls
          loop
          muted="muted"
        ></video>
      );
    } else if(this.props.liveNFTItem.mediaType === 1) {
      return (
        <img
          src={this.props.liveNFTItem.image}
          className="flex sm:absolute sm:z-10 rounded-md sm:mt-8 mx-auto w-72 sm:w-auto sm:h-96"
        />
      );
    }
    return (
      <img
        src={this.props.liveNFTItem.image}
        className="flex sm:absolute sm:z-10 rounded-md sm:mt-8 mx-auto w-72 sm:w-auto sm:h-96"
      />
    );
  }
}

export default LiveNFT;
